import { Count } from "@/components/shared/data-table/total-count";
import { InvoiceType } from "@/lib/constants/invoice-type";
import { InvoiceStatus } from "@/lib/constants/invoiceStatus";
import { useInvoiceLiveCountsSubscription } from "@/queries/invoices/live-counts/live-counts";

export const PayableTodosBadge = () => {
  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: {
      type: { value: InvoiceType.PAYABLE, op: "eq" },
      status: { value: InvoiceStatus.EXPORTED, op: "ne" },
    },
  });

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};

export const ReceivableTodosBadge = () => {
  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: {
      type: { value: InvoiceType.RECEIVABLE, op: "eq" },
      status: { value: InvoiceStatus.EXPORTED, op: "ne" },
    },
  });

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};
